export default __webpack_public_path__ + "static/media/KEYFI-BNB.14cf07ad.svg";